<mat-form-field [class.no-radius]="noRadius">
  <mat-select
    [placeholder]="placeholder"
    panelClass="max-content"
    (selectionChange)="selectionChanged($event)"
    [value]="value"
  >
    @if (withImage) {
      <mat-select-trigger>
        <span class="fi img-option" [ngClass]="'fi-' + value"></span>
        <span class="trigger-text">{{ value | uppercase }}</span>
      </mat-select-trigger>
    }
    @for (entity of entities; track entity) {
      <mat-option [value]="entity.value">
        <span class="fi img-option" [ngClass]="'fi-' + entity.value"></span>
        {{ entity.label }}
      </mat-option>
    }
  </mat-select>
  <span class="lsl-select-arrow" inlineSVG="/icons/icon-chevron-arrow.svg"></span>
</mat-form-field>
